import { StackProps, Theme } from "@mui/material";
import { SystemCssProperties } from "@mui/system";
import React, { ForwardedRef, forwardRef, PropsWithChildren } from "react";
import { MdsIconProps } from "../MdsIcon/MdsIcon";
import { IconTypography, IconTypographyProps } from "@sinch/components/typography/IconTypography/IconTypography";

interface IconListRowProps extends PropsWithChildren {
  containerProps?: StackProps;
  spacing?: StackProps["spacing"];
  icon: MdsIconProps["icon"];
  iconSize?: MdsIconProps["fontSize"];
  iconAlign?: IconTypographyProps["iconAlign"];
  color?: SystemCssProperties<Theme>["color"];
}

export const IconListRow = forwardRef(
  (
    { children, icon, iconSize = "small", iconAlign = "center" }: IconListRowProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => (
    <IconTypography
      ref={ref}
      icon={icon}
      iconAlign={iconAlign}
      iconColor={({ palette }) => palette.grey["800"]}
      iconSize={iconSize}
      sx={{
        minHeight: "26px",
        // top aligned rows need the row padding spelled out, minHeight alone would push the
        // single line content to the top of the row
        ...(iconAlign === "firstLine" ? { py: "2.5px" } : {}),
      }}
    >
      {children}
    </IconTypography>
  )
);
IconListRow.displayName = "IconListRow";
